/**
 * @author        sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   LinkPackColumns
 */

import { Flex } from '@chakra-ui/react'
import { locationDescriptorToString } from '@zcode/nr-utils'
import { useHistory } from 'react-router-dom'
import { LinkPackLink } from './LinkPackLink'
import type { HandleLinkClickArgs, LinkObject } from './types'

export interface LinkPackColumnsProps {
  isExpanded?: boolean
  analyticChannel?: string
  asButton?: boolean
  handleLinkClick?: (args: HandleLinkClickArgs) => void
  header?: string
  links: readonly LinkObject[]
  oneColumn?: boolean
  showDetailColumn?: boolean
  testId?: string
}

export const LinkPackColumns = ({
  analyticChannel,
  asButton,
  handleLinkClick,
  header,
  links,
  oneColumn,
  showDetailColumn,
  testId,
}: LinkPackColumnsProps) => {
  const history = useHistory()
  return (
    <Flex
      columnGap={oneColumn ? 0 : 6}
      flexDirection={oneColumn ? 'column' : 'row'}
      flexWrap="wrap"
    >
      {links.map((link) => {
        return (
          <LinkPackLink
            analyticChannel={analyticChannel}
            asButton={asButton}
            handleLinkClick={handleLinkClick}
            header={header}
            key={locationDescriptorToString(link.to, history) ?? link.href}
            link={link}
            oneColumn={oneColumn}
            showDetailColumn={showDetailColumn}
            testId={testId}
          />
        )
      })}
    </Flex>
  )
}
